export const locale = {
    lang: 'pl',
    data: {

    }
};
